import type { JoinDraft, QueryRelationDefinition, QueryTarget } from "../../types.js";

export function getAvailableManyToOneRelationsForParent(
  joins: JoinDraft[],
  parentTarget: QueryTarget,
  relations: QueryRelationDefinition[],
): QueryRelationDefinition[] {
  const existingRelationKeys = new Set(
    joins.filter((join) => join.parentTarget === parentTarget).map((join) => join.relationKey),
  );

  return relations.filter((relation) => !existingRelationKeys.has(relation.key));
}

export function canAssignRelationKeyForParent(
  joins: JoinDraft[],
  parentTarget: QueryTarget,
  relationKey: string,
  excludeJoinId?: string,
): boolean {
  return !joins.some(
    (join) =>
      join.id !== excludeJoinId &&
      join.parentTarget === parentTarget &&
      join.relationKey === relationKey,
  );
}